const namespace = 'dirtyForms';

export const SET_DIRTY_FORM = `${namespace}_SET_DIRTY_FORM`;
export const CLEAR_DIRTY_FORM = `${namespace}_CLEAR_DIRTY_FORM`;

export const setDirtyForm = (form, value = true) => (dispatch) => {
  dispatch({
    type: SET_DIRTY_FORM,
    payload: {
      form,
      value,
    },
  });
};

export const clearDirtyForm = () => (dispatch) => {
  dispatch({
    type: CLEAR_DIRTY_FORM
  });
};

export const checkDirtyForm = (form) => (dispatch, getState) => {
  const { dirtyForms } = getState();
  return dirtyForms[form];
};

export const isAnyDirtyForm = () => (dispatch, getState) => {
  const { dirtyForms } = getState();
  return !!Object.entries(dirtyForms).find(entry => entry[1]);
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dirty-forms.actions.js